export default {
  gamePlay: {
    playTitle: 'Howdy partner!',
    playInstructions:
      '<p>Shoot the targets by clicking or tapping them.</p><p>The targets will be different shapes, sizes, or colors</p>',
    playButton: 'Let’s go!',
  },
  rounds: {
    end: 'End of Round {{it.round}}',
    playNext: 'Play next round!',
    all: 'Excellent! You got {{it.correct}} trials correct!',
    some: 'Great job! You got {{it.correct}} trials correct in this round.',
    none: "Good try. Let's keep practicing!",
  },
  levelUp: {
    title: 'Amazing job, level up!!!',
    bodyRender: (level: number) =>
      `Moving to level ${level}, and you got some tickets!`,
  },
  gameComplete: {
    playTitle: 'Game Completed!',
    playInstructions: ' ',
    playButton: 'Back',
  },
  instructions: {
    size: [
      {
        title: 'Sharpshooters Wanted',
        body:
          'Shoot the targets by clicking them with your mouse.<br><br>\n' +
          'The targets will be different shapes and sizes.',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-sh.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          'Shapes can be small, medium or large.<br><br>\n' +
          'And they change sizes every time that they appear.',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-sh-2.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          "KEEP TRACK of each shape's size.<br><br>" +
          "At the end, you'll click each shape's LAST SIZE.",
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-ke.mp3',
      },
      {
        title: 'Ready to start?',
        body: 'Press yes to start, no to see the instructions again.',
        buttonText: 'yes',
        buttonText2: 'no',
        buttonAction: 'goToPlay',
        buttonAction2: 'goToBeginning',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-ready-to-start-press-ye.mp3',
      },
    ],
    color: [
      {
        title: 'Sharpshooters Wanted',
        body: 'Shoot the targets by clicking them with your mouse.\n<br><br>The targets will be different shapes and colors.',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-color-sharpshooters-wanted-sh.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          'Shapes come in lots of colors.\n<br><br>' +
          '\n' +
          'And they change color every time they appear!',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-color-sharpshooters-wanted-sh-2.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          "KEEP TRACK of each shape's color. \n<br><br>" +
          '\n' +
          "At the end, you'll click each shape's LAST COLOR.",
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-color-sharpshooters-wanted-ke.mp3',
      },
      {
        title: 'Ready to start?',
        body: 'Press yes to start, no to see the instructions again.',
        buttonText: 'yes',
        buttonText2: 'no',
        buttonAction: 'goToPlay',
        buttonAction2: 'goToBeginning',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-color-ready-to-start-press-ye.mp3',
      },
    ],
    cat: [
      {
        title: 'Sharpshooters Wanted',
        body:
          'Shoot the targets by clicking them with your mouse.\n<br><br>' +
          '\n' +
          'The targets will be different shapes, sizes, or colors.',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-sh.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          'Shapes can be small, medium or large.<br><br>\n' +
          'And they change sizes every time that they appear.',
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-sh-2.mp3',
      },
      {
        title: 'Sharpshooters Wanted',
        body:
          "KEEP TRACK of each shape's size.<br><br>" +
          "At the end, you'll click each shape's LAST SIZE.",
        buttonText: 'Shoot!',
        buttonAction: 'goToNext',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-sharpshooters-wanted-ke.mp3',
      },
      {
        title: 'Ready to start?',
        body: 'Press yes to start, no to see the instructions again.',
        buttonText: 'yes',
        buttonText2: 'no',
        buttonAction: 'goToPlay',
        buttonAction2: 'goToBeginning',
        audio:
          '/assets/games/ShapeShooter/audio/instructions-size-ready-to-start-press-ye.mp3',
      },
    ],
  },
};
